import { useUniversalBootstrap } from './useUniversalBootstrap';
import { useTrackingBootstrap } from './useTrackingBootstrap';

export const useBootstrap = (): boolean => {
  const trackingReady = useTrackingBootstrap();
  useUniversalBootstrap(trackingReady);
  return trackingReady;
};
